import { type FC } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useIntl } from 'react-intl'

import {
  type UserOrderResponseWithFlags,
  type UserOrderResponseWithFlagsSubOrdersInner,
} from '@redteclab/api/clients/bully'

import { Card, CardContent } from 'base-ui'

import { directContactFormOrderSelectionAccessorGetSelfServiceUrl } from '../../../../../direct-contact'
import { useGlobalConfigContext } from '../../../../../global-config'
import { type DirectContactFormValues } from '../../DirectContactFormModel'

import { DirectContactFormOrderProductsSelectionCardButton } from './DirectContactFormOrderProductsSelectionCardButton'
import { DirectContactFormOrderProductsSelectionCardContent } from './DirectContactFormOrderProductsSelectionCardContent'

export const DirectContactFormOrderProductsSelectionCard: FC<{
  isMiraklOrderReturnAvailable: boolean
  order: UserOrderResponseWithFlags
  subOrder: UserOrderResponseWithFlagsSubOrdersInner
}> = ({ isMiraklOrderReturnAvailable, order, subOrder }) => {
  const intl = useIntl()
  const config = useGlobalConfigContext()
  const { control } = useFormContext<DirectContactFormValues>()
  const subject = useWatch({ control, name: 'subject' })
  const orderNumber = order.orderMasterData?.orderNumber
  const { subOrderId } = subOrder

  if (!orderNumber || !subOrderId) {
    return null
  }

  const selfServiceUrl =
    directContactFormOrderSelectionAccessorGetSelfServiceUrl({
      config,
      formSubject: subject,
      intl,
      isMiraklOrderReturnAvailable,
      orderNumber,
      subOrder,
    })

  const cardContent = (
    <DirectContactFormOrderProductsSelectionCardContent
      order={order}
      selfServiceUrl={selfServiceUrl}
      subOrder={subOrder}
    />
  )

  if (selfServiceUrl) {
    return (
      <Card
        className="w-full rounded-m bg-light-primary-low shadow-m hover:bg-light-brand-medium"
        data-qa-id="direct-contact-form-order-selection-card"
      >
        <CardContent className="p-4">{cardContent}</CardContent>
      </Card>
    )
  }

  return (
    <DirectContactFormOrderProductsSelectionCardButton subOrder={subOrder}>
      {cardContent}
    </DirectContactFormOrderProductsSelectionCardButton>
  )
}
